import type { Patrol } from '@local/common-lib';
import {
  MoreVert as MoreIcon,
  Delete as RemoveIcon,
} from '@mui/icons-material';
import type { Theme } from '@mui/material';
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
  useMediaQuery,
} from '@mui/material';
import type { FC, MouseEventHandler } from 'react';
import { Fragment, useState } from 'react';

interface Props {
  assignment: Patrol.GuestAssignment;
  futurePatrol: boolean;
  guestId: string;
  handleRemove: (patrollerId: string) => void;
  isAdmin: boolean;
}

export const GuestAssignmentRow: FC<Props> = ({
  guestId,
  assignment,
  futurePatrol,
  handleRemove,
  isAdmin,
}) => {
  const smallScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm'),
  );
  const [clickedButton, setClickedButton] = useState<Element>();

  if (assignment.removed) return <Fragment />;

  const handleOpen: MouseEventHandler<HTMLButtonElement> = (e): void => {
    setClickedButton(e.currentTarget);
  };

  const handleClose = (): void => {
    setClickedButton(undefined);
  };

  const handleRemoveClick = (): void => {
    setClickedButton(undefined);
    handleRemove(guestId);
  };

  return (
    <TableRow key={guestId}>
      <TableCell>{assignment.name}</TableCell>
      <TableCell>{assignment.phone}</TableCell>
      {!smallScreen && <TableCell>{assignment.email}</TableCell>}
      {isAdmin && futurePatrol && (
        <TableCell sx={{ display: 'flex', justifyContent: 'end' }}>
          <IconButton onClick={handleOpen}>
            <MoreIcon />
          </IconButton>
          <Menu
            anchorEl={clickedButton}
            anchorOrigin={{
              horizontal: 'right',
              vertical: 'bottom',
            }}
            onClose={handleClose}
            open={!!clickedButton}
            transformOrigin={{
              horizontal: 'right',
              vertical: 'top',
            }}
          >
            <MenuItem onClick={handleRemoveClick}>
              <ListItemIcon>
                <RemoveIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Remove</ListItemText>
            </MenuItem>
          </Menu>
        </TableCell>
      )}
    </TableRow>
  );
};
